// 修正userId和member_id错乱的数据

export default function fixUserId() {
    if (
        localStorage.getItem('userId') &&
        localStorage.getItem('member_id') &&
        localStorage.getItem('userId').length < localStorage.getItem('member_id').length
    ) {
        // 统计fixed次数
        let fixedCount = localStorage.getItem('fixUserIdCount');
        localStorage.setItem('fixUserIdCount', fixedCount ? parseInt(fixedCount) + 1 : 1);

        let tempUserId = localStorage.getItem('userId');
        localStorage.setItem('userId', localStorage.getItem('member_id'));
        localStorage.setItem('member_id', tempUserId);
    }
}
